import { sanitizeHtml } from '@/utils/html';

// Paint containment keeps `position: fixed` and absolute content inside the field, so an HTML
// value cannot draw over the rest of the app
const HtmlValue = ({ html }: { html: string }) => (
  <span
    className="prose prose-bird prose-sm block max-w-none [contain:paint]"
    // html must already be sanitizeHtml output; DOM insertion skips the HTML parser's <p> auto-close, so block tags inside this span are safe
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

// Renders null when sanitizing strips the value down to nothing (e.g. a body that was only a <script> tag)
export const SanitizedHtmlValue = ({ html }: { html: string }) => {
  const safeHtml = sanitizeHtml(html);
  return safeHtml.trim() ? <HtmlValue html={safeHtml} /> : null;
};
